import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { VisualizationDashboardState } from './visualization-dashboard-state.model';
import { VisualizationDashboardStore } from './visualization-dashboard.store';

@Injectable({ providedIn: 'root' })
export class VisualizationDashboardStoreQuery extends QueryEntity<VisualizationDashboardState> {
  constructor(protected store: VisualizationDashboardStore) {
    super(store);
  }
}
